var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvPg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.055,14.242v2.039H23.719v9.477h-7.266v-9.477H6.07v-2.039H34.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.488,14.242h7.5L54.21,25.758h-6.819L35.707,14.242h7.711l7.5,8.742L58.488,14.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.477,45.297c-1.98,1.406-4.809,2.109-8.483,2.109H13.95v10.352H6.927V28.969h14.524   c3.349,0,6.019,0.742,8.01,2.227c1.99,1.484,2.985,3.783,2.985,6.895C32.446,41.488,31.456,43.891,29.477,45.297z M24.081,34.926   c-0.895-0.638-2.148-0.957-3.762-0.957H13.95v8.477h6.369c1.613,0,2.867-0.345,3.762-1.035c0.896-0.689,1.344-1.783,1.344-3.281   C25.425,36.632,24.977,35.564,24.081,34.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.508,37.953c-0.535-1.966-1.844-3.34-3.924-4.121c-1.163-0.43-2.455-0.645-3.879-0.645   c-2.723,0-4.961,0.874-6.712,2.622c-1.752,1.748-2.628,4.376-2.628,7.885c0,3.535,0.948,6.037,2.846,7.505   c1.896,1.469,4.054,2.203,6.472,2.203c2.371,0,4.314-0.579,5.829-1.737s2.447-2.675,2.8-4.552h-7.825v-4.805h14.09v15.449h-4.682   l-0.711-3.594c-1.362,1.361-2.586,2.32-3.672,2.878c-1.867,0.972-4.162,1.458-6.885,1.458c-4.483,0-8.155-1.32-11.016-3.963   c-2.983-2.654-4.475-6.284-4.475-10.891c0-4.658,1.506-8.393,4.521-11.204c3.014-2.811,6.999-4.216,11.956-4.216   c4.3,0,7.753,0.928,10.362,2.783c2.608,1.855,4.104,4.17,4.486,6.943H58.508z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvPg);
export default __webpack_public_path__ + "static/media/TV-PG.15ab3707e2a479ff0bf2d9cfa0c694d7.svg";
export { ForwardRef as ReactComponent };